import type { Dictionnaire } from '../type';

export const legal: Dictionnaire['legal'] = {
  documents: {
    cgu: 'Terms of Service',
    confidentialite: 'Privacy Policy',
    mentions: 'Legal Notice',
    version: (v: string) => `Version ${v}`,
  },
  consentement: {
    titrePlusieurs: 'OUR DOCUMENTS HAVE CHANGED',
    titreUn: 'A DOCUMENT HAS CHANGED',
    textePlusieurs: 'To keep using Sirocco, read the two documents below and accept them.',
    texteUn: 'To keep using Sirocco, read the document below and accept it.',
    accepter: 'Accept and continue',
    deconnecter: 'Sign out',
  },
  ecran: {
    resumeCgu: 'What you agree to by using Sirocco.',
    resumeConfidentialite: 'What data is collected, why, and for how long.',
    resumeMentions: 'Who publishes the app, who hosts it, how to reach us.',
    titre: 'Terms and privacy',
    accepte: (cgu: string, confidentialite: string, quand: number | null) =>
    `You accepted version ${cgu} of the Terms of Service and version ${confidentialite} of the Privacy Policy${quand ? ` on ${new Date(quand).toLocaleDateString('en-GB')}` : ''}.`,
  },
  lien: {
    impossible: "Couldn't open the page. Here is the address:",
  },
  miseAJour: {
    texte: "This version brings changes the app can't install on its own.",
    plusTard: 'Later',
    mettreAJour: 'Update',
    disponible: (version: string) => `Sirocco ${version} is available`,
  },
};
